import {
  Text,
  TokenTextAppearance,
  TextTag,
  Image,
  DesignTokenSizeEnum,
} from '@volkswagen-onehub/components-core';
import FooterRetailerAddress from './FooterRetailerAddress';
import FooterRetailerContact from './FooterRetailerContact';
import FooterRetailerTimes from './FooterRetailerTimes';
import FooterRetailerInfo from './FooterRetailerInfo';
import Box from '../../Box/Box';
import { useTribalContext } from '@/context/tribal';
import {
  getNewCarsDepartment,
  getRetailerAddress,
  getRetailerOpeningTimes,
} from '@/modules/utils/storeUtils';
import { FoundRetailers } from '@tribal-worldwide-london/fa-retailer-service-vwg';
import { getImageUrl } from '@/modules/utils/themeUtils';
import { SectionNames } from '@/analytics/sectionNames';

const FooterRetailer = ({
  retailerContact,
  retailerData,
}: {
  retailerContact: any;
  retailerData: FoundRetailers[];
}) => {
  const { contentManager, configManager } = useTribalContext();
  const dealerDepartmentInfo = retailerData[0]?.departments?.find(
    (department) => department.departmentType.name === 'Dealer'
  );

  const retailer =
    getNewCarsDepartment(retailerData[0]?.departments || []) ??
    dealerDepartmentInfo;
  const retailerAddress = getRetailerAddress([
    retailer?.street,
    retailer?.district,
    retailer?.town,
    retailer?.postcode,
  ]);


  const openingTimes = getRetailerOpeningTimes(retailer?.openingHours);

  return (
    <div>
      <Box
        as={Text}
        tag={TextTag.h3}
        appearance={TokenTextAppearance.bigcopy200}
        bold
        mb={DesignTokenSizeEnum.static300}
      >
        {contentManager.get('footer-retailer-title')}
      </Box>

      <FooterRetailerAddress
        name={retailer?.tradingName}
        address={retailerAddress}
      />

      <FooterRetailerInfo>
        <FooterRetailerContact
          img={
            retailerContact.contact.image &&
            <Image
              src={getImageUrl(configManager, retailerContact.contact.image)}
              alt={retailerContact.contact?.contactName ?? 'Retailer image'}
            />
          }
          name={retailerContact.contact.contactName}
          role={retailerContact.contact.role || contentManager.get('footer-contact-job-role')}
          tel={retailerContact.contact.contactPhone}
          email={retailerContact.contact.contactEmail}
        />
        {retailer?.openingHours && (
          <FooterRetailerTimes
            openingTimes={openingTimes}
            contactEmail={retailer?.contactEmail}
            retailerAddress={retailerAddress}
            retailerNumber={retailer?.telephone}
            sectionName={SectionNames.FOOTER}
          />
        )}
      </FooterRetailerInfo>
    </div>
  );
};

export default FooterRetailer;
